import React, { useCallback, useEffect, useState } from 'react'
import bepassCopyright from './images/bepass_copyright_dark.png'
import bepassLogo from './images/bepass_logo.png'
import bothLogo from './images/booth_logos.png'
import batfair from './images/logo-arena-mrv.png'
import './App.sass'

import { BASE } from './basedata/constants'

import FaceOnboard from './Biometric/FaceOnboard'
import FaceInstructions from './Biometric/FaceInstructions'
import UserSignup from './User/UserSignup'
import Welcome from './Welcome'
import SuccessHandler from './Biometric/StatesComponents/SuccessHandler'
import { Card } from 'react-bootstrap'

import {QrScanner} from '@yudiel/react-qr-scanner';


// interface QrReader {
//   facingMode: any
//   delay: any
//   onError: any
//   onScan: any
// }
// type Props = { data: Item[] };

const dateFormatter = (dateTime:string)=>{

  const options:any = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  const oldDate = new Date(dateTime)
  return oldDate.toLocaleDateString('pt-BR', options).split(',').join(' ')
}

function App() {
  
  const [green, setGreen] = useState(false);
  const [red, setRed] = useState(false);

  const [shouldScan, setShouldScan] = useState(false);
  const [ticketReason, setTicketReason] = useState('');

  const [usedTicket, setUsedTicket] = useState({
    have: false,
    date: '23/12',
    time: '--:--'
  })
  
  // const [showDialog, setDiaglog] = useState(false);
  // const [processing, setProcessing] = useState(false);
  // const [precScan, setPrecScan] = useState("");
  // const [selected, setSelected] = useState("environment");
  // const [errorMessage, setErrorMessage] = useState(null);



  const handleScan = async (scanData:any) => {
    console.log(`loaded data data`, scanData);

    if(shouldScan){
      return true
    }


    const hml_vars = new URLSearchParams(window.location.search);
    const gate_number = hml_vars.get('gate') || '13';

    setShouldScan(true)

    setUsedTicket({
      have: false,
      date: '30/01',
      time: '--/--'
    })

    fetch(`https://e574-177-69-58-1.ngrok-free.app/tickets/checkin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: BASE.api.token,
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        "hash": scanData,
        "checkInType": "hand-held",
        "checkInDevice": "online-app",
        "gateId": gate_number
      }
    )
    })
      .then((resg) => resg.json())
      .then((response) => {

        setShouldScan(true)

        if (response.status === 'success') {
          console.log('VARIOEs >>>> ', response)
          setGreen(true)
          setTimeout(() => {
            setGreen(false)
            setShouldScan(false)
          }, 2000);
        } else {
          console.log('VARIOEx >>>> ', response)

          if(response.status === 'double_entry'){
    
            const checkDate = response.checkInDate
            setUsedTicket({
              have: true,
              date: '- -',
              time: dateFormatter(checkDate)
            })
          }else if(response.status === 'wrong_gate'){
            setTicketReason(`Portão correto: ${response.gateId}`)
          }
          setRed(true)
          // setTimeout(() => {
          //   setRed(false)
          //   setShouldScan(false)
          // }, 3000);
        }
      })
      .catch((error) => {
        setTicketReason(`server`)
        setRed(true)
        console.log('ai meu naris')
        console.log(error)
        setShouldScan(false)
        return false
      })

  };
  // const handleError = (err:any) => {
  //   console.error(err);
  // };



  return (
    <>
    <div className={`qr-wrap ${green ? 'active':''} ${red ? 'error':''}`}>
    {red &&
      <div className="qr-text">
      {usedTicket.have ? (
      
                   <>
                   Utilizado em: <br/>{usedTicket.date}<br/><span>{usedTicket.time}</span>
                   </>
      ):(
        <>
        <span>Ingresso inválido <br/>
        {ticketReason}
        </span>
         </>
        )
      }

      <a href='#' className='btn btn-primary' onClick={() => {setShouldScan(false);setRed(false);}}>Escanear</a>
    </div>
    }
      <div className="qr-scan">
      <div className="qr-handler">
      <QrScanner
            onDecode={handleScan}
            onError={(error) => console.log(error?.message)}
        />
      </div>

    <p className="copyright">
        powered by{' '}
        <a href="http://bepass.com.br" rel="noreferrer" target="_blank">
          <img src={bepassLogo} className="logo-bepass" alt="bepass" />
        </a>
      </p>
      </div>
    </div>
  </>
  )
}

export default App
